import { render } from "./Headshot.vue?vue&type=template&id=7a9e6074&scoped=true&ts=true"
import script from "./Headshot.vue?vue&type=script&lang=ts"
export * from "./Headshot.vue?vue&type=script&lang=ts"

import "./Headshot.vue?vue&type=style&index=0&id=7a9e6074&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9e6074"]])

export default __exports__